import { observer } from 'mobx-react-lite';

import { journalSaves } from '@/features/journal/journal-save-state';
import { meetingSaves } from '@/features/meetings/meeting-save-state';

/**
 * Shows the failed meeting saves and journal saves to all users. Without
 * this banner, the user cannot see the failure.
 */
export const FailedSavesBanner = observer(function FailedSavesBanner() {
  const failedSaves = [
    ...meetingSaves.getFailed(),
    ...journalSaves.getFailed(),
  ];
  const total = failedSaves.length;
  if (total === 0) return null;

  const retryAll = () => {
    for (const entry of failedSaves) entry.retry();
  };

  return (
    // Compact pill, top-right inside the safe area: away from the header
    // toggle (top-left) and never over the chat composer (bottom)
    <div
      role="status"
      data-testid="failed-saves-banner"
      className="fixed right-4 z-[9991] flex items-center gap-3 rounded-full border border-border-strong bg-surface px-4 py-2 shadow-sm"
      style={{ top: 'calc(env(safe-area-inset-top) + 3.25rem)' }}
    >
      <span className="text-xs text-foreground">
        {total === 1 ? '1 change not saved' : `${total} changes not saved`}
      </span>
      <button
        type="button"
        className="rounded-full border border-border-strong bg-surface px-3 py-1 text-xs text-foreground"
        onClick={retryAll}
      >
        Retry
      </button>
    </div>
  );
});
